import TextField from '@material-ui/core/TextField';
import React from 'react';
import User from 'records/User';

export default function SlackForm(props: {user: User}) {
  const {user} = props;

  return (
    <>
      <div className="integration-row">
        <TextField
          label="Slack Email"
          variant="outlined"
          value={user.slackEmail || 'None set'}
          disabled
          helperText={'Contact your administrator to assign or change your slack email.'}
        />
      </div>
    </>
  );
}
